import {
    Box, Divider, Text
} from '@chakra-ui/react';
import React from 'react';

import { useProgressActivity } from '../../../../containers/question-container/hooks/use-progress-activity';
import { lokalisation } from '../../../../helpers/lokalisation';
import { UnitTestIntroProps } from './unit-tests-intro.types';

export const UnitTestsIntro: React.FC<UnitTestIntroProps> = ({
    uowTitle,
    activityName,
    maximumAttemptExceeded
}) => {
    const {
        messageBoxTxt: {
            questions,
            totalPoints,
            fluencyHeaderForExceedingMaximumAttempts
        },
        diagnosticIntroTxt
    } = lokalisation();
    const { questionsCount = 0 } = useProgressActivity();
    const pointsPerQuestion = 20;

    return (
        <Box className={'message-content'}>
            <Box className={'message-body'}>
                <Text
                    as={'h3'}
                    fontSize={{
                        base: '24px',
                        breakTabletLandscape: '30px'
                    }}
                    color={'neutral.900'}
                    lineHeight={{
                        base: '33.6px',
                        breakTabletLandscape: '39px'
                    }}
                    letterSpacing={{
                        base: '-0.2px',
                        breakTabletLandscape: '-0.8px'
                    }}
                >
                    {maximumAttemptExceeded ? <>{fluencyHeaderForExceedingMaximumAttempts}!</> : <strong>{uowTitle}</strong>}
                </Text>
                <Text
                    as={'h3'}
                    fontSize={{
                        base: '24px',
                        breakTabletLandscape: '30px'
                    }}
                    color={'primary.600'}
                    lineHeight={{
                        base: '31.2px',
                        md: '33.6px',
                        breakTabletLandscape: '39px'
                    }}
                    letterSpacing={{
                        base: '-0.2px',
                        breakTabletLandscape: '-0.8px'
                    }}
                    mt={'32px'}
                >{activityName}</Text>
                <Box className={'milestone-summary'} mb={'16px !important'}>
                    <div className={'num-stack'}>
                        <div className={'num-stack_content'} data-testid={'questions'}>
                            <div className={'num-label'}>{questionsCount}</div>
                            <div className={'num-description'}>{questions}</div>
                        </div>
                    </div>
                    <Divider
                        borderColor={'neutral.100'}
                        h={'calc(100% - 2 * 20px)'}
                        my={'20px'}
                        opacity={1}
                        orientation={'vertical'}
                    />
                    <div className={'num-stack'}>
                        <div className={'num-stack_content'} data-testid={'total-points'}>
                            <div className={'num-label'} data-testid={'total-points-value'}>
                                {maximumAttemptExceeded ? 0 : questionsCount * pointsPerQuestion}
                            </div>
                            <div className={'num-description'}>{totalPoints}</div>
                        </div>
                    </div>
                </Box>
                {maximumAttemptExceeded &&
                    <Text
                        as={'h3'}
                        color={'primary.600'}
                        mb={4}
                        fontSize={20}
                        lineHeight={1.4}
                    >{diagnosticIntroTxt.noPointsEarn}</Text>
                }
            </Box>
        </Box>
    );
};
